import axios from './axiosConfig';
import { createBrowserHistory } from "history";
import { logAction } from './logActions';
import { persistor } from '../../index';
//const API_URL = "https://api.test.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.test.raborisk.ai" 
    : "http://localhost:3000";



const history = createBrowserHistory();





export const logOut = () => {
    return (dispatch, getState) => {
        logAction(dispatch, getState, "LOGOUT", "User logged out");
        dispatch({ type: "LOG_USER_OUT" });
        persistor.purge();
    };
};




export const setSidebarCollapsed = (collapsed) => {
    return (dispatch) => {
        dispatch({ type: "SET_SIDEBAR_COLLAPSED", d: collapsed });
    };
};



export const login = (username, pwd, callback) => {
    return (dispatch) => {

        ////////console.log("test");
        dispatch({ type: "RESET_LOGIN" });


        axios.post(API_URL + "/api/auth/login2FA", { email: username, password: pwd })

            .then(({ data }) => {
                if(data.message === 'Verification code sent'){
                    //////console.log("Email Sent");
                    callback();
                } 

                // if (data && data.token) {  // Check if data and data.token are defined

                //     dispatch({ type: "LOG_USER_IN", token: data.token });
                //     history.push('/dashboards');
                //} 
                else {
                    //console.error("Token is undefined");
                    console.error("Email couldn't be sent");
                    dispatch({ type: "ERROR_LOGGIN_IN" });
                }
            }).catch((error) => {
                ////////console.log(error);
                if (error.response) {  // Check if error.response is defined
                    if (error.response.status === 400) {
                        dispatch({ type: "ERROR_EMAIL_NOT_EXIST" });
                    } else if (error.response.status === 401) {
                        dispatch({ type: "ERROR_PWD_LOGIN" });
                    } else if (error.response.status === 402) {
                        dispatch({ type: "ERROR_LOGGIN_IN" });
                    }
                } else {
                    console.error("Error response is undefined");
                    dispatch({ type: "ERROR_LOGGIN_IN" });
                }
            });

    };
};





export const verify2FA = (username, code) => {
    return (dispatch) => {
        dispatch({ type: "RESET_LOGIN" });

        //////console.log("Here");
        axios.post(API_URL + "/api/auth/verify2FA", { email: username, code: code })

            .then(({ data }) => {
                if (data && data.token) {  // Check if data and data.token are defined

                    dispatch({ type: "LOG_USER_IN", token: data.token });
                    history.push('/dashboards');
                } else {

                    console.error("Token is undefined");
                    dispatch({ type: "ERROR_LOGGIN_IN" });
                }
            }).catch((error) => {
                ////////console.log(error);
                if (error.response) {  // Check if error.response is defined
                    if (error.response.status === 400) {
                        dispatch({ type: "ERROR_EMAIL_NOT_EXIST" });
                    } else if (error.response.status === 401) {
                        //////console.log("Verification code incorrect");
                        dispatch({ type: "ERROR_VERFICATION_CODE" });
                    } else if (error.response.status === 402) {
                        dispatch({ type: "ERROR_LOGGIN_IN" });
                    }
                } else {
                    console.error("Error response is undefined");
                    dispatch({ type: "ERROR_LOGGIN_IN" });
                }
            });

    };
};
